export default __webpack_public_path__ + "static/media/guide-ph.c8717c2d.svg";